export const allPostsQuery = `*[_type == "post"] {
    _id,
    title,
    slug,
    excerpt,
    publishedAt,
    featured,
    claps,
    readTime,
    tooltip,
    mainImage {
      asset->{
        _id,
        url,
        originalFilename,
        alt,     
        title,        
        description,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      caption,
      alt
    },
    "author": author->name,
    categories[]->{ 
      title,
      description
    },
    "bodyText": pt::text(body),
    seo{
      metaTitle,
      metaDescription,
      seoKeywords,
      openGraph{
        title,
        description,
        image{
          asset->{
            _id,
            url,
            originalFilename,
            alt,     
            title,        
            description,
            metadata {
              dimensions {
                width,
                height
              }
            }
          },
          caption,
          alt
        }
      }
    }
  }`;
